import css from 'styled-jsx/css'

export const codeConductModalStyles = css`
  .modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.7);
    z-index: 1000;
    opacity: 0;
    visibility: hidden;
    transition: opacity 0.3s ease, visibility 0.3s ease;
  }

  .modal-overlay.visible {
    opacity: 1;
    visibility: visible;
  }

  .code-conduct-modal-container {
    position: relative;
    min-height: 400px;
    max-height: 90vh;
    overflow-y: auto;
  }

  /* Loading State */
  .code-conduct-modal-loading {
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 400px;
    padding: 40px 20px;
  }

  .loading-content {
    text-align: center;
    max-width: 400px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  .loading-content h3 {
    margin: 20px 0 10px 0;
    font-size: 1.5rem;
    font-weight: 600;
    color: #2c3e50;
  }

  .loading-content p {
    margin: 0;
    color: #7f8c8d;
    font-size: 1rem;
    line-height: 1.5;
  }

  /* Error State */
  .code-conduct-modal-error,
  .code-conduct-modal-acceptance-error {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    min-height: 400px;
    padding: 40px 20px;
    text-align: center;
  }

  .error-content {
    margin-bottom: 30px;
    max-width: 400px;
  }

  .error-content :global(.ion-icon) {
    font-size: 4rem;
    color: #e74c3c;
    margin-bottom: 20px;
  }

  .error-content h3 {
    margin: 0 0 15px 0;
    font-size: 1.5rem;
    font-weight: 600;
    color: #2c3e50;
  }

  .error-content p {
    margin: 0;
    color: #7f8c8d;
    font-size: 1rem;
    line-height: 1.5;
  }

  .error-actions {
    display: flex;
    gap: 15px;
    flex-wrap: wrap;
    justify-content: center;
  }

  /* Processing Acceptance */
  .code-conduct-modal-accepting {
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 400px;
    padding: 40px 20px;
  }

  .accepting-content {
    text-align: center;
    max-width: 400px;
  }

  .accepting-content h3 {
    margin: 20px 0 10px 0;
    font-size: 1.5rem;
    font-weight: 600;
    color: #27ae60;
  }

  .accepting-content p {
    margin: 0;
    color: #7f8c8d;
    font-size: 1rem;
    line-height: 1.5;
  }

  /* Contract Viewer */
  .code-conduct-contract-viewer {
    display: flex;
    flex-direction: column;
    height: 100%;
    min-height: 600px;
  }

  .contract-header {
    padding: 20px 20px 15px 20px;
    border-bottom: 1px solid #ecf0f1;
    background-color: #f8f9fa;
    text-align: center;
  }

  .contract-header h3 {
    margin: 0 0 10px 0;
    font-size: 1.5rem;
    font-weight: 600;
    color: #2c3e50;
  }

  .contract-header p {
    margin: 0;
    color: #7f8c8d;
    font-size: 0.95rem;
    line-height: 1.5;
  }

  .contract-document {
    flex: 1;
    min-height: 500px;
    padding: 0;
    background-color: #ffffff;
  }

  .contract-actions {
    padding: 20px;
    border-top: 1px solid #ecf0f1;
    background-color: #f8f9fa;
  }

  /* No Document State */
  .code-conduct-modal-no-document {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    min-height: 400px;
    padding: 40px 20px;
    text-align: center;
  }

  .no-document-content {
    margin-bottom: 30px;
    max-width: 400px;
  }

  .no-document-content :global(.ion-icon) {
    font-size: 4rem;
    color: #95a5a6;
    margin-bottom: 20px;
  }

  .no-document-content h3 {
    margin: 0 0 15px 0;
    font-size: 1.5rem;
    font-weight: 600;
    color: #2c3e50;
  }

  .no-document-content p {
    margin: 0;
    color: #7f8c8d;
    font-size: 1rem;
    line-height: 1.5;
  }

  .no-document-actions {
    display: flex;
    justify-content: center;
  }

  /* Responsive Design */
  @media (max-width: 768px) {
    .code-conduct-modal-container {
      max-height: 95vh;
    }

    .contract-header {
      padding: 15px;
      text-align: center;
    }

    .contract-header h3 {
      font-size: 1.25rem;
    }

    .contract-header p {
      font-size: 0.9rem;
    }

    .contract-document {
      min-height: 400px;
    }

    .contract-actions {
      padding: 15px;
    }

    .loading-content h3,
    .error-content h3,
    .accepting-content h3,
    .no-document-content h3 {
      font-size: 1.25rem;
    }

    .error-actions {
      flex-direction: column;
      align-items: center;
    }

    .error-actions :global(button) {
      width: 100%;
      max-width: 200px;
    }
  }

  @media (max-width: 480px) {
    .code-conduct-modal-loading,
    .code-conduct-modal-error,
    .code-conduct-modal-accepting,
    .code-conduct-modal-no-document {
      padding: 20px 15px;
    }

    .contract-header {
      padding: 12px;
      text-align: center;
    }

    .contract-actions {
      padding: 12px;
    }

    .contract-document {
      min-height: 350px;
    }
  }
`

export const oldVersionCodeConductModalStyles = css`
  .code-conduct-modal-old-version {
    padding: 2rem;
    text-align: center;
    max-width: 600px;
    margin: 0 auto;
  }

  .old-version-header {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 1.5rem;
  }

  .old-version-icon {
    font-size: 2.5rem;
    color: #f39c12;
    margin-right: 1rem;
  }

  .old-version-header h3 {
    margin: 0;
    color: #2c3e50;
    font-size: 1.5rem;
    font-weight: 600;
  }

  .old-version-message {
    margin-bottom: 2rem;
  }

  .main-message {
    font-size: 1.1rem;
    color: #34495e;
    margin-bottom: 1.5rem;
    line-height: 1.6;
  }

  .loading-message {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.5rem;
    color: #3498db;
    font-weight: 500;
  }

  .error-message {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.5rem;
    color: #e74c3c;
    background: #ffeaea;
    padding: 1rem;
    border-radius: 8px;
    border-left: 4px solid #e74c3c;
  }

  .contract-action p {
    font-size: 1.1rem;
    margin-bottom: 1.5rem;
    color: #2c3e50;
  }

  .contract-link {
    color: #3498db;
    text-decoration: none;
    font-weight: 600;
    border-bottom: 2px solid #3498db;
    transition: all 0.3s ease;
  }

  .contract-link:hover {
    color: #2980b9;
    border-bottom-color: #2980b9;
  }

  .action-buttons {
    display: flex;
    gap: 1rem;
    justify-content: center;
    flex-wrap: wrap;
  }

  .action-buttons button {
    min-width: 160px;
  }

  .fallback-message {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.5rem;
    color: #95a5a6;
    background: #f8f9fa;
    padding: 1rem;
    border-radius: 8px;
  }

  .old-version-note {
    display: flex;
    align-items: flex-start;
    gap: 0.5rem;
    background: #f8f9fa;
    padding: 1rem;
    border-radius: 8px;
    border-left: 4px solid #f39c12;
    text-align: left;
    font-size: 0.9rem;
    color: #7f8c8d;
    margin-top: 2rem;
  }

  .old-version-note ion-icon {
    color: #f39c12;
    margin-top: 2px;
    flex-shrink: 0;
  }

  @media (max-width: 768px) {
    .code-conduct-modal-old-version {
      padding: 1.5rem;
    }

    .old-version-header {
      flex-direction: column;
      gap: 0.5rem;
    }

    .old-version-icon {
      margin-right: 0;
      margin-bottom: 0.5rem;
    }

    .sign-button-container, {
      flex-direction: column;
      align-items: center;
    }

    .refresh-button-container {
      flex-direction: column;
      align-items: center;
      margin-top: 1rem;
    }

    .action-buttons button {
      width: 100%;
      max-width: 300px;
    }
  }
`
